import {makeProductsPage} from "src/core/pages/productsPagesFactory";
import routes from "src/core/common/routes";
import React from "react";
import {PageHead} from "src/core/seo/components/Head";
import {saveProduct} from "src/server/preloader/productPage";
import useThemeConfig from "src/themes/useThemeConfig";

function ProductDetailPage(props) {
  const config = useThemeConfig();
  const ThemedProductDetailPage = config.pages.ProductDetailPage;

  return <ThemedProductDetailPage {...props} />;
}

function makeProductDetailPage() {
  const Component = makeProductsPage(() => ({pathname: routes.home}), ProductDetailPage);

  return (props) => {
    saveProduct(props);
    const {product} = props;

    return (
      <>
        <Component {...props} />
        {product && (
          <PageHead
            title={product.attributes.name}
            description={product.attributes.description}
            image={product.attributes.main_image}
          />
        )}
      </>
    );
  };
}

export default makeProductDetailPage;
